"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Accordion_1 = tslib_1.__importDefault(require("@mui/material/Accordion"));
const AccordionDetails_1 = tslib_1.__importDefault(require("@mui/material/AccordionDetails"));
const AccordionSummary_1 = tslib_1.__importDefault(require("@mui/material/AccordionSummary"));
const styles_1 = require("@mui/material/styles");
const CardContentError_1 = tslib_1.__importDefault(require("../CardContentError"));
const Accordion = (0, styles_1.styled)(Accordion_1.default)({
    ".Mui-expanded": {
        margin: "auto",
    },
    "&:before": {
        display: "none",
    },
    "&:not(:last-child)": {
        borderBottom: 0,
    },
    boxShadow: "none",
    cursor: "default",
});
const AccordionSummary = (0, styles_1.styled)(AccordionSummary_1.default)({
    ".MuiAccordionSummary-content": {
        ".Mui-expanded": {
            margin: "0",
        },
        cursor: "default",
        display: "block",
        margin: "0px",
    },
    ".Mui-expanded": {
        minHeight: 56,
    },
    display: "none",
});
const AccordionDetails = (0, styles_1.styled)(AccordionDetails_1.default)(({ theme }) => ({
    cursor: "default",
    padding: theme.spacing(1),
}));
/**
 *
 * @category component
 */
const ExpandableTechnicalInformation = ({ children, expanded }) => (react_1.default.createElement(CardContentError_1.default, null,
    react_1.default.createElement(Accordion, { square: true, expanded: expanded },
        react_1.default.createElement(AccordionSummary, null),
        react_1.default.createElement(AccordionDetails, null, children))));
exports.default = ExpandableTechnicalInformation;
